import Router from 'next/router';

import {
	PostErrorResetPasswordResponse,
	PostErrorResponse,
	PostRegisterErrorResponse,
} from 'services/idm';

type ApiError =
	| PostErrorResponse
	| PostErrorResetPasswordResponse
	| PostRegisterErrorResponse;

export function apiErrorHandler(error: ApiError | any, lang = 'en') {
	if (error && error.status && error.status === 500) {
		void Router.push(`/${lang}/error/500`);
	}
}
